import { CSSProperties, FC, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Stack, Box } from "@mui/material";
import { useDidMount } from "rooks";
import { grey } from "@mui/material/colors";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureDiagramSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramSelector";

export const InfrastructureArchitectureDiagram: FC = () => {
  const diagram = useAppSelector(infrastructureArchitectureDiagramSelector);
  const wrapperRef = useRef<any>(null);

  useDidMount(() => {
    if (wrapperRef.current) {
      wrapperRef.current.setTransform(0, 0, 1, 0, 0, "easeOutQuad");
      wrapperRef.current.zoomToElement(
        wrapperRef.current.contentComponent,
        1,
        0,
        0,
        "easeOutQuad",
      );
    }
  });

  if (!diagram) {
    return null;
  }

  return (
    <Stack height="100%" width="100%" justifyContent="center" overflow="hidden">
      <Box height="100%" width="100%">
        <TransformWrapper
          smooth
          ref={wrapperRef}
          initialScale={1}
          minScale={0.5}
          maxScale={10}
          centerOnInit
          limitToBounds
          wheel={wheelConfigs}
        >
          <TransformComponent
            wrapperStyle={transformComponentWrapperStyle}
            contentStyle={transformComponentContentStyle}
          >
            <img
              src={`data:image/png;base64, ${diagram}`}
              alt="diagram"
              style={diagramImgStyle}
            />
          </TransformComponent>
        </TransformWrapper>
      </Box>
    </Stack>
  );
};

const transformComponentWrapperStyle = {
  height: "100%",
  width: "100%",
  backgroundColor: "white",
  backgroundImage: `radial-gradient(circle, ${grey[200]} 1px, transparent 1px)`,
  backgroundSize: "15px 15px",
};
const transformComponentContentStyle = {
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "white",
  backgroundImage: `radial-gradient(circle, ${grey[200]} 1px, transparent 1px)`,
  backgroundSize: "12px 12px",
};

const wheelConfigs = {
  step: 1,
  smoothStep: 0.005,
  touchPadDisabled: false,
};

const diagramImgStyle = {
  width: "100%",
  height: "100%",
  objectFit: "contain" as CSSProperties["objectFit"],
  display: "block",
};
